import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { CategoryService } from 'app/core/category/category.service';
import { InitialData } from 'app/modules/admin/manage-franchise-category/franchise-category.types';
import { FranchiseService } from 'app/core/franchise/franchise.service';

@Injectable({
    providedIn: 'root'
})
export class FranchiseCategoryDataResolver implements Resolve<any>
{
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _categoryService: FranchiseService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<InitialData> {
        return this._categoryService.getFranchiseCategories()
            .pipe(
                map((categories) => ({
                    categories
                })
                ),
                catchError(err => {
                    this._categoryService.errorMessage = err.error.message ? err.error.message : "Something went wrong !";
                    return of(new DefaultResponse().categories);
                })
            );
    }

}
class DefaultResponse implements InitialData {
    categories: any = [];
}